// extracted by mini-css-extract-plugin
export default {"incut":"gve2wcLf","mobile":"mobile","icon":"OjFph5Ck"};